<h1 mat-dialog-title >Nueva baja</h1>
<div mat-dialog-content>
  <form [formGroup]="bajaForm">
    <p style="color: black; font-weight: bold"  >Escoja una opción:</p><br>
    <mat-radio-group formControlName="tipo" (change)="changeEstado($event)">
      <mat-radio-button value="BAJA TEMPORAL VOLUNTARIA" >Baja temporal voluntaria</mat-radio-button><br>
      <mat-radio-button value="BAJA EXPORTACION" >Baja exportación</mat-radio-button><br>
    </mat-radio-group>
    <br>
    <div class="row">
      <mat-form-field appearance="outline" class="col-lg-4 col-md-4 col-sm-4 col-4" *ngIf="show">
        <mat-label>País de destino</mat-label>
        <input matInput matNativeControl type="text" formControlName="paisDestino">
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12">
        <mat-label>Número de pedido</mat-label>
        <input matInput matNativeControl type="text"
               formControlName="numPedido">

      </mat-form-field>
    </div>
  </form>
</div>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancelar</button>
  <button mat-button [disabled]="bajaForm.invalid" [mat-dialog-close]="bajaForm">Siguiente</button>
</mat-dialog-actions>
